import { useMemo, useState } from 'react'
import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@shared/design-system/ui'
import { FeatureFlagsProvider } from '@shared/feature-flags/FeatureFlagsProvider'
import { featureFlagUserFromSession } from '@shared/feature-flags/featureFlagUserFromSession'
import { useSession } from '@shared/lib/auth/session-store'
import { createQueryClient } from '@shared/lib/query/query-client'
import { SessionHydrator } from './SessionHydrator'

export type AppProvidersProps = {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(() => createQueryClient())
  const user = useSession((state) => state.user)
  const featureFlagUser = useMemo(() => featureFlagUserFromSession(user), [user])

  return (
    <FeatureFlagsProvider user={featureFlagUser}>
      <QueryClientProvider client={queryClient}>
        <SessionHydrator />
        {children}
        <Toaster />
      </QueryClientProvider>
    </FeatureFlagsProvider>
  )
}
